import Axios from "axios";

class OrganizationTagService {

    readonly basePath = "/organization-tags";

    public getList(): Promise<string[]> {
        return Axios.get(`${this.basePath}`).then(response => response.data);
    }

}

export default OrganizationTagService;
